import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import { trans, getResourcePath } from '@spotahome/soyuz/client';

import './PropertyTypeSectionCard.scss';

const PropertyTypeSectionCard = ({ type }) => {
  const PropertyTypeSectionCardName = trans(
    `property.type.section.card.${type}`
  );
  const PropertyTypeSectionCardDescription = trans(
    `property.type.section.card.description.${type}`
  );

  return (
    <div className="property-type-section-card">
      <LazyLoad height={200} offset={[150, 150]} once>
        <figure className="property-type-section-card__image">
          <img
            src={getResourcePath(`/images/home/property-type/${type}.jpg`)}
            alt={PropertyTypeSectionCardName}
          />
        </figure>
      </LazyLoad>

      <div className="property-type-section-card__info">
        <h3 className="property-type-section-card__info-title">
          {PropertyTypeSectionCardName}
        </h3>
        <span className="property-type-section-card__info-description">
          {PropertyTypeSectionCardDescription}
        </span>
      </div>
    </div>
  );
};

PropertyTypeSectionCard.propTypes = {
  type: PropTypes.string.isRequired
};
export default PropertyTypeSectionCard;
